//#region INTERFACE INotificationChips
/**
 * ### INotificationChips
 * Represents the state of notification filter chips.
 *
 * @interface INotificationChips
 * @extends Object
 * @default {@link DEFAULT_NOTIFICATIONS_CHIPS}
 * @description Flags for filtering notifications by type, status, and read/unread states.
 *
 * @example
 * const chipsState: INotificationChips = {
 *   allMessages: true,
 *   autoOrder: true,
 *   fail: false,
 *   stockUpdate: true,
 *   success: false,
 *   readMessages: false,
 *   unreadMessages: false
 * };
 */
export interface INotificationChips extends Object {
  /** Indicates whether the "All Messages" chip is selected. */
  allMessages: boolean;

  /** Indicates whether the "Auto Order" chip is selected. */
  autoOrder: boolean;

  /** Indicates whether the "Fail" chip is selected. */
  fail: boolean;

  /** Indicates whether the "Quotes" type is selected. */
  quotes: boolean;

  /** Indicates whether the "Read Messages" chip is selected. */
  readMessages: boolean;

  /** Indicates whether the "Stock Take" chip is selected. */
  stockTake: boolean;

  /** Indicates whether the "Stock Update" chip is selected. */
  stockUpdate: boolean;

  /** Indicates whether the "Success" chip is selected. */
  success: boolean;

  /** Indicates whether the "Unread Messages" chip is selected. */
  unreadMessages: boolean;
}

//#endregion

//#region CONST DEFAULT_NOTIFICATIONS_CHIPS
/**
 * ### DEFAULT_NOTIFICATIONS_CHIPS
 * Default state configuration for notification filter chips.
 *
 * @constant
 * @type {INotificationChips}
 * @default
 * {
 *   allMessages: true,
 *   autoOrder: true,
 *   fail: false,
 *   stockUpdate: true,
 *   success: false,
 *   readMessages: false,
 *   unreadMessages: false,
 * }
 *
 * @description
 * This default object is used to initialize the filter chips UI state
 * controlling which types and statuses of notifications are shown by default.
 */
export const DEFAULT_NOTIFICATIONS_CHIPS: INotificationChips = {
  allMessages: true,
  autoOrder: true,
  fail: false,
  quotes: true,
  stockUpdate: true,
  stockTake: true,
  success: false,
  readMessages: false,
  unreadMessages: false,
};
//#endregion
